var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoSmallBlue = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.27782 23.0352C8.72713 23.6562 10.3234 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 15.0415 1.13155 17.8187 2.99663 19.9337L1.34489 22.0625C0.664479 22.9394 1.43702 24.1907 2.52586 23.9753L7.27782 23.0352Z",
    fill: "url(#paint0_radial_2750_9413)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.675293 15.9789L5.58024 10.8482C6.38485 10.0066 7.67749 9.8639 8.6463 10.5098L10.9988 12.0781C11.5557 12.4494 12.3087 12.2933 12.6721 11.7313L15.3906 7.52779C15.3906 7.52779 15.8203 6.97051 16.4119 7.3091C17.0035 7.6477 16.7426 8.30573 16.7426 8.30573L14.2546 15.1592C13.7236 16.622 11.9623 17.2004 10.6674 16.3372L8.3804 14.8125C7.85682 14.4635 7.15254 14.5781 6.76675 15.0753L2.99649 19.9335C1.98665 18.7884 1.19186 17.4491 0.675293 15.9789Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2750_9413",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.04275 24) rotate(-64.5044) scale(21.1185 20.5786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0780DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31A3FB"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoSmallBlue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/LogoSmallBlue.c81a8205ae5f3416ddd9d15956216572.svg";